// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"brightcovePlayer_videoContainer__2RvTb","offset":"brightcovePlayer_offset__2WU2Q","wotd":"brightcovePlayer_wotd__LSP4L"};